import {Component} from '@angular/core';

@Component({
  selector: 'survey-signup-thanks',
  templateUrl: './thank_you.html'
})
export class SurveySignupThanksCmp {
}
